var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ArticleCategories.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-07f4322e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ArticleCategories.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Article/ArticleCategories.vue
// module id = 576
// module chunks = 0